// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3UNck","colMaxWidth":"Table_colMaxWidth__2lFWE"};